import { render } from "./gradeBook.vue?vue&type=template&id=532db8f0"
import script from "./gradeBook.vue?vue&type=script&lang=js"
export * from "./gradeBook.vue?vue&type=script&lang=js"

import "./gradeBook.vue?vue&type=style&index=0&id=532db8f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__